/**
 * Types for Medical Consultations feature
 * Supports consultation continuation and idempotency detection
 */

/**
 * Represents a matched existing consultation for a member and charge code combination.
 * Used to detect if a consultation already exists before creating a new one.
 *
 * @interface ConsultationMatch
 */
export interface ConsultationMatch {
  consultationId: string;
  memberId: string;
  chargeCode: string | null;
  outcome: string;
  redirectUrl: string | null;
  status: string;
  startedOn: string;
  chargeAmountFormatted?: string | null;
  serviceProviderName?: string | null;
  mainMemberId?: string | null;
  isDependant?: boolean;
  consultationTypeName?: string;
}

/**
 * Enum defining the routing decision for consultation continuation.
 * Determines which flow to follow based on detected consultation state.
 *
 * @enum {string}
 */
export enum ConsultationRoute {
  NEW_CONSULTATION = "NEW_CONSULTATION",
  PAYMENT_FLOW = "PAYMENT_FLOW",
  INTERCARE_LINK = "INTERCARE_LINK",
  DEFER_TO_WORKFLOW = "DEFER_TO_WORKFLOW",
}

/**
 * Result object returned from consultation detection logic.
 * Contains the matched consultation (if any), loading state, and error information.
 *
 * @interface ConsultationDetectionResult
 */
export interface ConsultationDetectionResult {
  match: ConsultationMatch | null;
  error: Error | null;
  loading: boolean;
}
